import React from 'react';

import { 
  styled, colors, transitionDefault, fluidRange, 
  breakpoints, respondTo, css, absoluteFill, calcRem 
} from '~/styles';
import { ResourceItemModeProps } from './ResourceItem';
import { ResourcesItemActions, StyledTitle, StyledType } from './ResourcesItemCommon';


const StyledItem = styled.li`
  display: block;
  background-color: ${colors.white};
  padding: 10px;
  ${fluidRange('paddingRight', '10px', '40px', breakpoints.md, breakpoints.xl)}
  /* margin-bottom: 19px; */
  margin-bottom: ${calcRem(20)};
  text-align: left;
  cursor: pointer;
  
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  ${transitionDefault};
  transition-property: transform, background-color;

  &:hover {
    /* transform: translateY(-1px); */
    background-color: #F8F8F8;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  &.hide {
    display: none;
  }
`

const StyledThumbnail = styled.div`
  width: 100px;
  height: 100px;
  background-size: cover;
  background-color: #aaa;
  flex: 0 0 100px;
  ${fluidRange('marginRight', '15px', '20px', breakpoints.xs, breakpoints.md)}

  ${respondTo(breakpoints.md, css`
    width: 35%;
    padding-bottom: 35%;
    flex-basis: 35%;
    height: 0;
    align-self: flex-start;

    img {
      ${absoluteFill};
    }
  `)};
`

const StyledMain = styled.div`
  flex: 1 0 0;
  display: flex;
  flex-flow: row;
  align-items: center;

  ${respondTo(breakpoints.md, css`
    flex: 1 1 0;
    align-self: stretch;
    padding-top: 0.2em;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
  `)};
`

const StyledMainTitles = styled.div`
  display: flex; 
  flex-flow: column;
  flex: 0 1 30%;
  ${fluidRange('marginRight', '10px', '20px', breakpoints.xs, breakpoints.md)}
`

const StyledDescription = styled.div`
  flex: 1 0 0;
  ${fluidRange('paddingRight', '20px', '35px', breakpoints.md, breakpoints.xl)}
  ${fluidRange('paddingLeft', '20px', '35px', breakpoints.md, breakpoints.xl)}
  position: relative;
  line-height: 1.33;
  font-size: ${calcRem(21.5)};

  /* separator */
  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 1px;
    height: 100%;
    background: black;
    left: 0;
    min-height: 80px;
    top: 50%;
    transform: translateY(-50%);
  }

  ${respondTo(breakpoints.md, css`
    ${fluidRange('fontSize', '12px', '21.5px', breakpoints.xs, breakpoints.md)}
    padding: 0;
    padding-top: 0.8em;
    flex: 0 0 0;
    justify-self: flex-end;
    margin-top: auto;  /* why doesn't justify-self work?.. */

    &:before {
      display: none;
    }
  `)};
  
`



const ResourceItemModeList: React.FC<ResourceItemModeProps> = ({ 
  resource, thumbnailBgStyle, openResourceModal 
}) => {
  function createTitle() {
    return {
      __html: resource.title
    }
  }

  function createDescription() {
    return {
      __html: resource.description
    }
  }

  return (

    <StyledItem
      onClick={() => openResourceModal(resource)}
    >
      <StyledThumbnail style={thumbnailBgStyle} />
      <StyledMain>
        <StyledMainTitles>
          <StyledTitle dangerouslySetInnerHTML={createTitle()} />
          <StyledType>{resource.type} { resource.supplemental_text ? '/ ' + resource.supplemental_text : null }</StyledType>
        </StyledMainTitles>
        <StyledDescription dangerouslySetInnerHTML={createDescription()} />
      </StyledMain>
      <ResourcesItemActions resource={resource} />
    </StyledItem>
  )
}
export default ResourceItemModeList;



// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourceItemModeList.tsx